import { useState } from "react"

import { faCircle } from "@fortawesome/free-solid-svg-icons"
import { faTimes } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Grid from "@mui/material/Grid"

import { Typography } from "@mui/material"

const ErrorDialog = ({ title, message }) => {
  const [open, setOpen] = useState(true)

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs">
      <Grid container direction="column" alignItems="center">
        <Box bgcolor="error.light" width="1" mb={2} textAlign="center">
          <Grid item my={2}>
            <DialogTitle id="alert-dialog-title">
              <Box className="fa-layers fa-fw text-center fa-3x" color="error.main">
                <FontAwesomeIcon icon={faCircle} color="error.main" />
                <FontAwesomeIcon icon={faTimes} color="error.contrastText" inverse size="xs" />
              </Box>
            </DialogTitle>
          </Grid>
        </Box>
        <DialogContent my={2}>
          <Typography align="center" variant="h4" paragraph>
            {title}
          </Typography>
          <Typography align="center" paragraph>
            {message}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Box mb={3}>
            <Button onClick={handleClose} color="primary" variant="contained">
              OK
            </Button>
          </Box>
        </DialogActions>
      </Grid>
    </Dialog>
  )
}
export default ErrorDialog
